import { PlatformList } from "Components/PlatformList";

const PlatformPage = () => <PlatformList />;

export default PlatformPage;
